import {NextSeo} from 'next-seo';
import {useRouter} from 'next/router';

const Layout = ({children, meta}) => {
	const router = useRouter();
	const DEFAULT_SEO = {
		title: 'Food For Change | Feed Australia, One Click at a Time',
		description:
			'Discover a world of amazing products and make a positive impact with our new e-commerce marketplace, powered by BetterThat Connect.',
		keywords: 'marketplace',
		openGraph: {
			type: 'website',
			locale: 'en_IE',
			url: `${process.env.SITE_URL}${router.asPath}`,
			title: 'Food For Change | Feed Australia, One Click at a Time',
			description:
				'Discover a world of amazing products and make a positive impact with our new e-commerce marketplace, powered by BetterThat Connect.',
			// eslint-disable-next-line camelcase
			site_name: 'Food For Change',
			images: [
				{
					url: `${process.env.SITE_URL}/img/main-logo.png`,
					width: 164,
					height: 46,
					alt: 'Fishing-in-Godzone',
				},
			],
		},
	};

	return (
		<>
			<NextSeo {...DEFAULT_SEO} />
			<>{children}</>
		</>
	);
};

export default Layout;
